import { Helmet } from 'react-helmet';
import { useState, useEffect } from 'react';
import * as S from './Courses.styles';
import { CDN_BASE_URL } from '../../config';
import { getSiteContent } from '../../api/siteContentApi';

// Default course data (fallback)
const DEFAULT_COURSES = [
  {
    "id": 1,
    "title": "Pre-Primary - Year 3 Extension",
    "description": "Ignite a lifelong love for learning with our engaging Pre-Primary to Year 3 Extension program. Tailored for young minds, this course builds strong foundations in literacy and numeracy through fun, interactive lessons. Our expert tutors foster critical thinking and confidence, ensuring your child thrives in their early educational journey and beyond.",
    "image": "english.webp"
  },
  {
    "id": 2,
    "title": "Year 4 - Year 6 (Term 1) Gate",
    "description": "Unlock your child's potential with our Year 4-5 GATE preparation program. The Gifted and Talented Education (GATE) program selects students for specialized academic opportunities in Western Australia's top schools. Our targeted curriculum sharpens analytical thinking and problem-solving skills through challenging, dynamic lessons, empowering students to excel in GATE entrance exams and secure their place in gifted programs.",
    "image": "gate.png"
  },
  {
    "id": 3,
    "title": "Year 6 (Term 2) - Year 10 Extension",
    "description": "Elevate academic performance with our Year 6-10 Extension program. Designed for ambitious students, this course offers enriched content and accelerated learning in core subjects. Our expert tutors guide students to master advanced concepts, hone critical analysis, and develop effective study habits, paving the way for outstanding success in senior secondary school.",
    "image": "y6english_writing.jpg"
  },
  {
    "id": 4,
    "title": "Year 10 - Year 12 ATAR Program",
    "description": "Achieve university dreams with our intensive Year 10-12 ATAR program. The Australian Tertiary Admission Rank (ATAR) determines university entry in Australia, and our expert tutors provide comprehensive support across all ATAR subjects. With personalized coaching, proven exam strategies, and time management skills, students are equipped to maximize their scores and secure their future.",
    "image": "atar.jpg"
  },
  {
    "id": 5,
    "title": "Other Specialised Courses",
    "description": "We also offer specialised courses designed to target key academic skills. These include:",
    "specializedList": [
      "Writing Courses: to build strong structure, vocabulary, and expression across various text types.",
      "Reading Comprehension: to develop critical thinking, inference, and analysis skills.",
      "Novel Study: to enhance literary understanding through guided reading and discussion.",
      "AMC Preparation: to sharpen mathematical reasoning and problem-solving for competition success."
    ],
    "image": "personalised.png"
  }
];

const Courses = () => {
  const [courses, setCourses] = useState(DEFAULT_COURSES);
  const [loadedImages, setLoadedImages] = useState({});
  const [errorImages, setErrorImages] = useState({});

  // Load custom courses from API
  useEffect(() => {
    getSiteContent('courses').then(data => {
      if (data) setCourses(data);
    });
  }, []);

  // 统一的图片URL获取函数
  const getCourseImageUrl = (imageName) => {
    return `${CDN_BASE_URL}/static/course/${imageName}`;
  };

  const handleImageLoad = (imageUrl) => {
    setLoadedImages(prev => ({ ...prev, [imageUrl]: true }));
  };

  const handleImageError = (imageUrl) => {
    setErrorImages(prev => ({ ...prev, [imageUrl]: true }));
  };

  return (
    <S.Container>
      <Helmet>
        <title>Uplus Education - Courses</title>
        <meta name="description" content="Comprehensive education from Pre-Primary to Year 12, including GATE and ATAR preparation programs" />
      </Helmet>

      <h1>Our Courses</h1>
      <p style={{ marginBottom: '3rem', fontSize: '1.1rem', color: '#666' }}>
        Comprehensive education programs from Pre-Primary to Year 12, designed to help students excel academically.
      </p>

      {/* 课程列表 */}
      <S.CourseList>
        {courses.map(course => {
          const imageUrl = getCourseImageUrl(course.image);
          return (
            <S.CourseRow key={course.id}>
              <S.CourseImage>
                <img
                  src={imageUrl}
                  alt={course.title}
                  onLoad={() => handleImageLoad(imageUrl)}
                  onError={() => handleImageError(imageUrl)}
                  style={{
                    opacity: loadedImages[imageUrl] ? 1 : 0,
                    transition: 'opacity 0.3s ease'
                  }}
                />
                {!loadedImages[imageUrl] && !errorImages[imageUrl] && (
                  <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    color: '#999'
                  }}>
                    Loading...
                  </div>
                )}
              </S.CourseImage>
              
              <S.CourseContent>
                <S.CourseTitle>{course.title}</S.CourseTitle>
                <S.CourseDescription>{course.description}</S.CourseDescription>
                {course.specializedList && (
                  <S.SpecializedList>
                    {course.specializedList.map((item, index) => (
                      <S.SpecializedItem key={index}>
                        {item}
                      </S.SpecializedItem>
                    ))}
                  </S.SpecializedList>
                )}
              </S.CourseContent>
            </S.CourseRow>
          );
        })}
      </S.CourseList>
      
    </S.Container>
  );
};

export default Courses;